export namespace CoffeeProperties {
  export type CaffeineContentEnum = 'CAFFEINATED' | 'DECAFFEINATED';
  export const CaffeineContentEnum = {
    Caffeinated: 'CAFFEINATED' as CaffeineContentEnum,
    Decaffeinated: 'DECAFFEINATED' as CaffeineContentEnum,
  };
  export type ProcessingLevelEnum = 'RAW' | 'ROASTED';
  export const ProcessingLevelEnum = {
    Raw: 'RAW' as ProcessingLevelEnum,
    Roasted: 'ROASTED' as ProcessingLevelEnum,
  };
  export type AppearanceFormEnum =
    | 'COFFEE_EXTRACT_CONTAINS_REAL_COFFEE'
    | 'ESSENE_AND_CONCENTRATE_EXTRACT'
    | 'PREPARATION_BASED_ON_ESSENCE_AND_CONCENTRATE'
    | 'PREPARATION_BASED_ON_COFFEE';
  export const AppearanceFormEnum = {
    CoffeeExtractContainsRealCoffee:
      'COFFEE_EXTRACT_CONTAINS_REAL_COFFEE' as AppearanceFormEnum,
    EsseneAndConcentrateExtract:
      'ESSENE_AND_CONCENTRATE_EXTRACT' as AppearanceFormEnum,
    PreparationBasedOnEssenceAndConcentrate:
      'PREPARATION_BASED_ON_ESSENCE_AND_CONCENTRATE' as AppearanceFormEnum,
    PreparationBasedOnCoffee:
      'PREPARATION_BASED_ON_COFFEE' as AppearanceFormEnum,
  };
  export type TypeEnum =
    | 'BEANS'
    | 'GROUND'
    | 'INSTANT'
    | 'COFFEE_CAPSULE_AND_PILLOW';
  export const TypeEnum = {
    Beans: 'BEANS' as TypeEnum,
    Ground: 'GROUND' as TypeEnum,
    Instant: 'INSTANT' as TypeEnum,
    CoffeeCapsuleAndPillow: 'COFFEE_CAPSULE_AND_PILLOW' as TypeEnum,
  };
}
